<script setup>
defineProps({
  items: { type: Array, required: true },
});

// Función para verificar si un item es de tipo selector
const esSelectorItem = (item) => item.definicion?.tipo_nota?.selector;

// Función para verificar si un item es de tipo texto
const esTextoItem = (item) => item.definicion?.tipo_nota?.tipo_nota === 'texto';

// Función para obtener las opciones de un item específico
const obtenerOpcionesItem = (item) => {
  const tipoNota = item.definicion?.tipo_nota;
  if (tipoNota?.selector && tipoNota?.opciones) {
    return tipoNota.opciones;
  }
  return [];
};
</script>

<template>
  <table class="table tabla-items-diarios">
    <tbody>
      <tr
        v-for="item in items"
        :key="item.id"
        class="fila-item"
      >
        <td class="text-center columna-imagen">
          <img
            v-if="item.definicion?.foto_url"
            :src="item.definicion.foto_url"
            :alt="item.definicion?.nombre"
            class="imagen-item"
          >
          <span v-else class="sin-imagen">
            <i class="fal fa-image text-muted"></i>
          </span>
        </td>
        <td class="columna-nombre">
          {{ item.definicion?.nombre }}
        </td>
        <td class="columna-opciones">
          <template v-if="esSelectorItem(item)">
            <div class="opciones-container">
              <div
                v-for="opcion in obtenerOpcionesItem(item)"
                :key="opcion.valor"
                class="opcion-item"
                :class="{ 'opcion-seleccionada': item.valor === opcion.valor }"
                :title="opcion.nombre"
                data-toggle="tooltip"
              >
                <span class="opcion-valor">{{ opcion.valor }}</span>

              </div>
            </div>
          </template>
          <div v-else class="valor-texto">
            <span :class="{ 'text-2x': !esTextoItem(item) }">
              {{ item.valor }}
            </span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<style lang="scss" scoped>
@import "@/../assets/stylesheets/cifra/vars/main.scss";

.tabla-items-diarios {
  margin-bottom: 0;

  .columna-imagen {
    width: 80px;
    min-width: 80px;
    vertical-align: middle;
  }

  .columna-nombre {
    min-width: 200px;
    width: 100%;
    vertical-align: middle;
  }

  .columna-opciones {
    min-width: 200px;
    vertical-align: middle;
  }

  td {
    vertical-align: middle;
  }

  .imagen-item {
    max-width: 60px;
    max-height: 60px;
    border-radius: 4px;
  }

  .sin-imagen {
    display: inline-block;
    width: 60px;
    height: 60px;
    line-height: 60px;
    border: 1px dashed $color-secondary;
    border-radius: 4px;

    i {
      font-size: 24px;
    }
  }

  .opciones-container {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
  }

  .opcion-item {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    border: 1px solid $border-color;
    border-radius: 4px;
    background-color: $light-gray;
    transition: all 0.2s ease;
    min-width: 50px;
    justify-content: center;
    opacity: 0.6;
    filter: grayscale(100%);

    &.opcion-seleccionada {
      background-color: transparent !important;
      color: $color-cifra;
      border-color: $color-muted;
      border-width: 2px;
      opacity: 1;
      filter: none;

      .opcion-check {
        color: $color-cifra;
      }

      .opcion-valor {
        font-weight: bold;
      }
    }

    .opcion-valor {
      font-weight: bold;
      font-size: 14px;
    }

    .opcion-check {
      font-size: 12px;
      margin-left: 4px;
      font-weight: bold;
    }

    &:hover:not(.opcion-seleccionada) {
      background-color: #e9ecef;
      opacity: 0.8;
      filter: grayscale(70%);
    }
  }

  .valor-texto {
    text-align: center;
    padding: 8px;
  }

  .fila-item {
    &:hover {
      background-color: #f5f5f5;
    }
  }
}
</style>
